// @flow

import type {
  ChecklistFieldType,
  LinkedFieldType,
  chatPickListField,
  TaskField,
  GroupField,
  workflowField
} from "src/types";

const makeChecklistCtor = (type: string) =>
  function ({
    label = "",
    importError = false,
    autoCheck = false,
    settings,
    excludeFromCollapse
  }: ChecklistFieldType) {
    this.label = label;
    this.importError = importError;
    this.autoCheck = autoCheck;
    this.settings = settings;
    this.type = type;
    this.excludeFromCollapse = excludeFromCollapse;
  };

const text = makeChecklistCtor("text");
const richtext = makeChecklistCtor("richtext");
const number = makeChecklistCtor("number");
const date = makeChecklistCtor("date");
const user = makeChecklistCtor("user");
const conversation = makeChecklistCtor("conversation");
const childConversation = makeChecklistCtor("childConversation");
const select = makeChecklistCtor("select");
const pdf = makeChecklistCtor("pdf");
const section = makeChecklistCtor("section");
const subSection = makeChecklistCtor("subSection");
const file = makeChecklistCtor("file");
const form = makeChecklistCtor("form");
const approval = makeChecklistCtor("approval");
const revision = makeChecklistCtor("revision");
const ai = makeChecklistCtor("ai");

function link({
  label = "",
  importError = false,
  autoCheck = false,
  settings,
  sourceProcessSettings,
  linkedProcessSettings,
  excludeFromCollapse
}: LinkedFieldType) {
  this.label = label;
  this.importError = importError;
  this.autoCheck = autoCheck;
  this.settings = settings;
  this.type = "link";
  /*
    WARNING: The reason for the following code is because some notifications
    have `sourceProcessSettings` as an Object in the transit instead of a
    stringified JSON. Since the notification data is not fixed and to prevent
    crashes we are accommodating this bug.
    Remove this hack only after confirmation that NONE of the notifications
    have an incorrect transit.
  */
  this.sourceProcessSettings =
    typeof sourceProcessSettings === "string"
      ? JSON.parse(sourceProcessSettings || "{}")
      : sourceProcessSettings || {};
  this.linkedProcessSettings =
    typeof linkedProcessSettings === "string"
      ? JSON.parse(linkedProcessSettings || "{}")
      : linkedProcessSettings || {};
  this.excludeFromCollapse = excludeFromCollapse;
}

// Old Transit Types
function chatPickList({
  label = "",
  isRequired = false,
  placeholder = "Choose the chat",
  isChecked = false,
  settings = {}
}: chatPickListField) {
  this.label = label;
  this.isRequired = isRequired;
  this.placeholder = placeholder;
  this.isChecked = isChecked;
  this.settings = settings;
  this.type = "chatPickList";
}

function workflow({
  label = "",
  isRequired = false,
  placeholder = "Choose the workflow template",
  isChecked = false,
  settings = {}
}: workflowField) {
  this.label = label;
  this.isRequired = isRequired;
  this.placeholder = placeholder;
  this.isChecked = isChecked;
  this.settings = settings;
  this.type = "workflow";
}

function task({
  label = "",
  isRequired = false,
  placeholder = "start the task",
  isChecked = false
}: TaskField) {
  this.label = label;
  this.isRequired = isRequired;
  this.placeholder = placeholder;
  this.isChecked = isChecked;
  this.type = "task";
}

function group({
  label = "",
  isRequired = false,
  placeholder = "start the chat",
  isChecked = false
}: GroupField) {
  this.label = label;
  this.isRequired = isRequired;
  this.placeholder = placeholder;
  this.isChecked = isChecked;
  this.type = "group";
}

const transitTypes = {
  form,
  section,
  subSection,
  text,
  number,
  date,
  user,
  conversation,
  select,
  chatPickList,
  file,
  workflow,
  pdf,
  task,
  group,
  childConversation,
  approval,
  revision,
  link,
  richtext,
  ai
};

// Must be sorted alphabetically
export const newTransitTypes = {
  ai,
  approval,
  childConversation,
  date,
  file,
  form,
  link,
  number,
  conversation, // parentConversation
  pdf,
  select, // picklist
  revision,
  richtext,
  section,
  subSection,
  text,
  user
};

export default transitTypes;
